import PropTypes from "prop-types";

// Semantic's list styles outrank the utilities layer, so the margin and padding
// resets carry the `!` suffix.
const ChangeList = ({ children }) => (
  <ul
    data-slot="change-list"
    className="tw:my-1! tw:list-disc tw:pl-5! tw:text-(--color-text-secondary)"
  >
    {children}
  </ul>
);

ChangeList.propTypes = {
  children: PropTypes.node,
};

export default ChangeList;
